<template>
	<router-link
		v-if="!children"
		active-class="navbar-item-active"
		:class="['navbar-item', gtmtag]"
		:to="item.path"
		:data-test="`nav-${item.title.toLowerCase()}`"
	>
		<span :class="{ 'badge-holder': item.badge }">
			<span v-if="item.badge" class="badge">{{ item.badge }}</span>
			{{ item.title }}</span
		>
	</router-link>
	<div v-else class="navbar-item has-dropdown is-hoverable">
		<a class="navbar-link">{{ item.title }}</a>
		<div class="navbar-dropdown">
			<router-link
				v-for="(child, index) in children"
				:key="index"
				active-class="navbar-item-active"
				class="navbar-item"
				:to="child.path"
				>{{ child.title }}</router-link
			>
		</div>
	</div>
</template>

<script>
import { slugify } from "@/utils/format";
export default {
	props: {
		item: {
			type: Object,
			required: true
		}
	},
	computed: {
		children() {
			const { children } = this.item;
			return children.length ? children : null;
		},
		gtmtag() {
			return `gtm-header-nav-${slugify(this.item.title)}`;
		}
	},
	methods: {}
};
</script>
